'use client';

import Button from 'components/buttons/button';
import Anchor from 'components/typography/anchor';
import { useChatChannel } from 'hooks/useChatChannel';
import appleIcon from 'images/icons/apple.svg';
import ctaIcon from 'images/icons/messages-square.svg';
import { cn } from 'lib/utils';
import type React from 'react';
import config, { DATA_TYPES } from 'siteconfig';
import {
  POSTHOG_SIGNUP_EVENT_SMS,
  POSTHOG_SIGNUP_EVENT_WEB_CHAT,
} from 'utilities/analytics';

interface CTAProps {
  shareCode?: string;
  copy?: string;
  type?: (typeof DATA_TYPES)[keyof typeof DATA_TYPES];
  isClosed?: boolean;
  keyword?: string;
  className?: string;
}

const CTA: React.FC<CTAProps> = ({
  shareCode,
  copy = 'Sign Petition',
  type = DATA_TYPES.PETITION,
  isClosed = false,
  keyword: keywordOverride,
  className,
}) => {
  const generatedKeyword = !isClosed ? `${type.trigger} ${shareCode}` : '';
  const keyword = keywordOverride || generatedKeyword;

  const { supportsAppleMessages, isDeepLink, webChatHref, href, eventName } =
    useChatChannel(keyword);

  return (
    <div
      className={cn(
        'max-sm:fixed max-sm:bottom-0 max-sm:left-0 max-sm:z-50 max-sm:w-screen max-sm:border-t max-sm:border-stone-200 max-sm:py-5 max-sm:text-center max-sm:backdrop-blur-sm sm:mb-5 max-sm:dark:border-stone-700',
        className
      )}
    >
      <Button
        theme="blue"
        href={href}
        iconSrc={supportsAppleMessages ? appleIcon : ctaIcon}
        eventName={eventName}
      >
        {copy}
      </Button>
      <p className="mt-1.5 text-sm font-light text-stone-500">
        {isDeepLink ? (
          <>
            {supportsAppleMessages ? 'Opens in Messages.' : 'Opens your texts.'}{' '}
            <Anchor
              className="anchor-subtle font-bold"
              href={webChatHref}
              eventName={POSTHOG_SIGNUP_EVENT_WEB_CHAT}
            >
              Chat on the web
            </Anchor>{' '}
            instead.
          </>
        ) : (
          <>
            Or text <strong className="font-bold">{keyword}</strong> to{' '}
            <Anchor
              className="anchor-subtle font-bold"
              href={config.channelUrls.sms + keyword}
              eventName={POSTHOG_SIGNUP_EVENT_SMS}
            >
              50409
            </Anchor>
          </>
        )}
      </p>
    </div>
  );
};

export default CTA;
